import { MDBBtn, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import SuccessIcon from "../../../Assets/sucessIcon.svg"
// import { VisaeroJumbotron } from '../../Common/VisaeroJumbotron'

const EnquiryFormSuccessfull = (props) => {
    const [refNo, setRefNo] = useState('')
    const history = useHistory()

    const handleOkSubmit = () => {

        history.push('/new-visa')
    }


    useEffect(() => {
        if (props.location.state?.reference_num) {
            setRefNo(props.location.state?.reference_num)
        }
        // console.log(props.location)

    }, [])

    return (
        <>
            {/* <VisaeroJumbotron jumbotrontext="Apply New Visa" /> */}
            <div style={{ height: 'calc(100vh - 203px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', boxShadow: '-2px 2px 13px 0 hsl(0deg 0% 82% / 30%)', borderRadius:'.25rem', border:".5px solid #f0f0f0" }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ fontSize: '14px', fontWeight: 500, lineHeight: '18px', maxWidth: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center   ', gap: '30px' }} >
                        <img src={SuccessIcon} alt="" style={{ height: '100px', width: '100px' }} />
                        <div>
                            Your enquiry is submitted successfully.
                            Your reference number is <br /> {refNo}&nbsp;
                            Our representative will contact you shortly.
                        </div>
                        <MDBRow style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <MDBBtn color="none" style={{ color: 'white', backgroundColor: localStorage.getItem('brand_color'), fontSize: 'calc(8px + .5rem)', textTransform: 'none', minWidth: '100px' }} onClick={handleOkSubmit}>Ok</MDBBtn>
                        </MDBRow>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EnquiryFormSuccessfull